import React from 'react';
import Icon from '../ui/icons'; // Angenommen, dies ist der Pfad zu Ihrer optimierten Icon-Komponente

const MenuItem = ({ title, icon, menu, subtitle }) => {
    return (
        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 mb-4">
            <a href={`index.php/${menu}`} className="settings-card w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                {icon && <Icon name={icon} size={40} className="mb-2" />}
                <span className="font-20">{title}</span>
                <p className={`font-12`} style={{ opacity: '0.7', textAlign: 'center' }}>{subtitle}</p>
            </a>
        </div>
    );
}

export default MenuItem;